/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CustomForm from 'cio/models/custom-form';
import FacebookLeadAdsForm from 'cio/models/facebook-lead-ads-form';
import { FormIntegrationDetailPanes } from 'cio/components/forms/custom/integration-details';

interface FormsCustomSendFormDataModalArgs {
  form: FacebookLeadAdsForm | CustomForm | null;
  onClose: () => unknown;
  detailsToShow: FormIntegrationDetailPanes;
}

export default class FormsCustomSendFormDataModal extends Component<FormsCustomSendFormDataModalArgs> {}
